// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__DeGk7","vLegacy":"SelectSecondary_vLegacy__32Wls","error":"SelectSecondary_error__1BTnr","disabled":"SelectSecondary_disabled__b6QGK"};